function initializeCalculator() {

  const calculatorComponent = $('#auto-payment-calculator')

  if (calculatorComponent.length > 0) {

    const loanType = $('#drpLoanType')
    const creditScore = $('#drpCreditScore')
    const loanAmount = $('#txtLoanAmount')
    const term = $('#drpTerm')

    loanType.on('change', function () {
      ReloadCalculator();
    })

    creditScore.on('change', function () {
      ReloadCalculator();
    })

    loanAmount.on('focusout', function () {
      ReloadCalculator();
    })

    term.on('change', function () {
      ReloadCalculator();
    })
  }


  function ReloadCalculator() {
    $.ajax({
      url: '/webapi/autopaymentrateapi/rates',
      method: 'POST',
      data: JSON.stringify({
        LoanType: String($('#drpLoanType').find(':selected').val()),
        Amount: $('#txtLoanAmount').val(),
        Terms: $('#drpTerm').find(':selected').val(),
        RateColumn: String($('#drpCreditScore').find(':selected').val())
      }),
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      success: function (response) {
        $('#drpTerm > option').each(function () {
          $(this).prop('disabled', false);
        });

        $('#monthlyPayment').html(response.monthlyPayment);
        $('#rate').html(response.rate);
        let availableTermArray = response.availableTerms;

        if (availableTermArray !== null) {
          $('#drpTerm > option').each(function () {
            if (availableTermArray.indexOf(parseInt($(this).val())) < 0) {
              $(this).prop('disabled', true);
            }
          });
        }
        
        if (response.monthlyPayment == '$') {
          $('#calculator-warning').removeClass('d-none');
        }
        else {
          $('#calculator-warning').addClass('d-none');
        }
      },
      error: function (errorMsg) {
        console.log(errorMsg);
      }
    })
  }
}


document.addEventListener('DOMContentLoaded', (event) => {
  initializeCalculator()
})
